document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-rz-header]').forEach(function (header) {
    var openButton = header.querySelector('[data-rz-wishlist-open]');
    var closeButton = header.querySelector('[data-rz-wishlist-close]');
    var drawer = header.querySelector('[data-rz-wishlist-drawer]');
    var backdrop = header.querySelector('[data-rz-wishlist-backdrop]');
    var itemsRoot = header.querySelector('[data-rz-wishlist-items]');
    var count = header.querySelector('[data-rz-wishlist-count]');
    var headingCount = header.querySelector('[data-rz-wishlist-heading-count]');
    var productCache = new Map();
    var renderVersion = 0;
    if (!openButton || !closeButton || !drawer || !backdrop || !itemsRoot) return;

    function read() {
      try {
        var saved = JSON.parse(localStorage.getItem('rizznova:wishlist') || '[]');
        return Array.isArray(saved) ? saved.filter(function (item) { return item && item.handle; }) : [];
      } catch (error) { return []; }
    }
    function write(saved) {
      localStorage.setItem('rizznova:wishlist', JSON.stringify(saved));
      document.dispatchEvent(new CustomEvent('rz:wishlist:changed'));
    }
    function money(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: document.querySelector('[data-rz-search-currency]')?.getAttribute('data-rz-search-currency') || 'USD'
        }).format(amount);
      } catch (error) { return '$' + amount.toFixed(2); }
    }
    function refreshCartDrawer() {
      var section = document.getElementById('shopify-section-cart-drawer-section');
      if (!section) return Promise.resolve();
      var url = new URL(window.location.href);
      url.searchParams.set('sections', 'cart-drawer-section');
      return fetch(url.toString(), { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (sections) {
          var html = sections && sections['cart-drawer-section'];
          if (!html) return;
          var template = document.createElement('template');
          template.innerHTML = html.trim();
          var replacement = template.content.querySelector('#shopify-section-cart-drawer-section');
          section.innerHTML = replacement ? replacement.innerHTML : html;
        })
        .catch(function () {});
    }
    function setOpen(open) {
      drawer.hidden = !open;
      backdrop.hidden = !open;
      drawer.setAttribute('aria-hidden', String(!open));
      openButton.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('rz-wishlist-open', open);
      if (open) {
        render();
        window.setTimeout(function () { closeButton.focus(); }, 40);
      } else {
        openButton.focus({ preventScroll: true });
      }
    }
    function card(product) {
      var article = document.createElement('article');
      article.className = 'rz-wishlist-item';
      var media = document.createElement('a');
      media.className = 'rz-wishlist-item__media';
      media.href = '/products/' + product.handle;
      var image = document.createElement('img');
      image.src = product.featured_image || (product.images && product.images[0]) || '';
      image.alt = product.title;
      image.loading = 'lazy';
      media.appendChild(image);

      var body = document.createElement('div');
      body.className = 'rz-wishlist-item__body';
      var title = document.createElement('a');
      title.className = 'rz-wishlist-item__title';
      title.href = media.href;
      title.textContent = product.title;
      var price = document.createElement('span');
      price.className = 'rz-wishlist-item__price';
      var select = document.createElement('select');
      select.className = 'rz-wishlist-item__variant';
      select.setAttribute('aria-label', 'Choose an option for ' + product.title);
      (product.variants || []).forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title + (variant.available ? '' : ' — Sold out');
        option.disabled = !variant.available;
        select.appendChild(option);
      });
      var firstAvailable = (product.variants || []).filter(function (variant) { return variant.available; })[0];
      if (firstAvailable) select.value = firstAvailable.id;
      function selectedVariant() {
        return (product.variants || []).filter(function (variant) { return String(variant.id) === select.value; })[0];
      }
      function updatePrice() {
        var variant = selectedVariant();
        price.textContent = variant ? money(variant.price) : 'Unavailable';
      }
      select.addEventListener('change', updatePrice);
      updatePrice();

      var actions = document.createElement('div');
      actions.className = 'rz-wishlist-item__actions';
      var add = document.createElement('button');
      add.type = 'button';
      add.className = 'rz-wishlist-item__add';
      add.textContent = firstAvailable ? 'Add to Bag' : 'Sold out';
      add.disabled = !firstAvailable;
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'rz-wishlist-item__remove';
      remove.textContent = 'Remove';
      var status = document.createElement('span');
      status.className = 'rz-wishlist-item__status';
      status.setAttribute('aria-live', 'polite');

      remove.addEventListener('click', function () {
        write(read().filter(function (item) { return item.handle !== product.handle; }));
      });
      add.addEventListener('click', function () {
        var variant = selectedVariant();
        if (!variant) return;
        add.disabled = true;
        status.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to add this item.');
          status.textContent = 'Added to Bag.';
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { delta: 1 } }));
          return refreshCartDrawer();
        }).catch(function (error) {
          status.textContent = error.message;
        }).then(function () { add.disabled = false; });
      });

      actions.appendChild(add);
      actions.appendChild(remove);
      body.appendChild(title);
      body.appendChild(price);
      if ((product.variants || []).length > 1) body.appendChild(select);
      body.appendChild(actions);
      body.appendChild(status);
      article.appendChild(media);
      article.appendChild(body);
      return article;
    }
    function loadingCard(item) {
      var loading = document.createElement('article');
      loading.className = 'rz-wishlist-item rz-wishlist-item--loading';
      loading.setAttribute('aria-busy', 'true');
      loading.setAttribute('aria-label', 'Loading saved item');
      loading.dataset.productHandle = item.handle;
      var message = document.createElement('span');
      message.className = 'rz-wishlist-item__status';
      message.textContent = 'Loading saved item…';
      loading.appendChild(message);
      return loading;
    }
    function unavailableCard(item) {
      var unavailable = document.createElement('article');
      unavailable.className = 'rz-wishlist-item rz-wishlist-item--unavailable';
      var message = document.createElement('span');
      message.className = 'rz-wishlist-item__status';
      message.textContent = 'This saved item is temporarily unavailable.';
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'rz-wishlist-item__remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        write(read().filter(function (savedItem) { return savedItem.handle !== item.handle; }));
      });
      unavailable.appendChild(message);
      unavailable.appendChild(remove);
      return unavailable;
    }
    function fetchProduct(item) {
      if (productCache.has(item.handle)) return Promise.resolve(productCache.get(item.handle));
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (product) {
          if (product) productCache.set(item.handle, product);
          return product;
        })
        .catch(function () { return null; });
    }
    function render() {
      var saved = read();
      var currentVersion = ++renderVersion;
      count.textContent = saved.length;
      count.hidden = saved.length === 0;
      if (headingCount) headingCount.textContent = '(' + saved.length + ')';
      itemsRoot.innerHTML = '';
      if (!saved.length) {
        var empty = document.createElement('div');
        empty.className = 'rz-wishlist-empty';
        var message = document.createElement('p');
        message.textContent = 'No saved items yet.';
        var shop = document.createElement('a');
        shop.href = '/collections/all';
        shop.textContent = 'Continue shopping';
        empty.appendChild(message);
        empty.appendChild(shop);
        itemsRoot.appendChild(empty);
        return;
      }
      saved.forEach(function (item) {
        var placeholder = loadingCard(item);
        itemsRoot.appendChild(placeholder);
        fetchProduct(item).then(function (product) {
          if (currentVersion !== renderVersion || !placeholder.isConnected) return;
          placeholder.replaceWith(product ? card(product) : unavailableCard(item));
        });
      });
    }

    openButton.addEventListener('click', function () { setOpen(true); });
    closeButton.addEventListener('click', function () { setOpen(false); });
    backdrop.addEventListener('click', function () { setOpen(false); });
    header.querySelectorAll('[data-rz-search-open]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) setOpen(false);
    });
    document.addEventListener('rz:wishlist:changed', render);
    document.addEventListener('rz:wishlist:render', render);
    render();
  });
});
